import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import useGetShareLink from 'components/Modal/ShareLinkModal/hooks/useGetShareLink';
import { saveRecruiterJobPost, deleteRecruiterJobPost } from '../actions';

const useJobPostNavigation = (jobPostId: number) => {
  const dispatch = useDispatch();

  const saveRecruiterJobPostHandler = useCallback(
    () => dispatch(saveRecruiterJobPost({ jobPostId })),
    [dispatch, jobPostId]
  );

  const deleteRecruiterJobPostHandler = useCallback(
    () => dispatch(deleteRecruiterJobPost({ jobPostId })),
    [dispatch, jobPostId]
  );

  const { getShareLinkHandler } = useGetShareLink(jobPostId);

  return { saveRecruiterJobPostHandler, deleteRecruiterJobPostHandler, getShareLinkHandler };
};

export default useJobPostNavigation;
